import parse from 'html-react-parser';
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import PageError from 'pages/404';
import { useState } from 'react';
import Layout from 'src/components/layouts';
import { APP_URL, SHOW_COMMEMORATE } from 'src/constants';
import { decryptionClient } from 'src/services/member-auth/utils/decryption-payload';
import { timestamp, useDesktop } from 'src/utils/helper';
import { GET } from 'src/utils/services';
import useUser from 'src/utils/useUser';
import styled from 'styled-components';

const PrivacyPolicyPage = ({ privacyDataArray, dataAdsHeader }) => {
  const _data = useUser();
  const sessionSevId = _data?.user ? decryptionClient(_data?.user) : null;
  const [checkedState, setCheckedState] = useState([true, false, false]);
  const arrayName = ['นโยบายการใช้คุกกี้', 'ข้อกำหนดและเงื่อนไข', 'คำประกาศเกี่ยวกับความเป็นส่วนตัว'];
  function handleOnChange (position) {
    const newUpdate = [false, false, false];
    newUpdate[position] = true;
    setCheckedState(newUpdate);
  };
  const _findIndex = findIndex(checkedState, (e) => (e === true));

  if (isEmpty(privacyDataArray[0]) || isEmpty(privacyDataArray[1]) || isEmpty(privacyDataArray[2])) return <PageError dataAdsHeader={dataAdsHeader} sessionSevId={sessionSevId} />;
  // <div dangerouslySetInnerHTML={{ __html: privacyDataArray[index] }} /> // index is a policy no. //still in section tag
  return (
    <>
      <NextSeo
        noindex={true}
        nofollow={true}
        title='นโยบายการเป็นส่วนตัว การเข้าเยี่ยมชมเว็บไซต์ www.tnews.co.th'
        description='เพื่อสร้างความเชื่อมั่นและความเข้าใจเกี่ยวกับการใช้บริการของ www.tnews.co.th บริษัท ไทย นิวส์ แอนด์ เอ็นเตอร์เทนเมนท์ เวิลด์ จำกัด'
      />
      <Head>
        <link rel='canonical' href={`${APP_URL}/privacy-policy`} />
        {/* -------------------------------- ADS : PPN ------------------------------- */}
        {!useDesktop() && !isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_mobile}`) : ''}
        {useDesktop() && !isEmpty(dataAdsHeader) ? parse(`${dataAdsHeader?.header_desktop}`) : ''}
        {/* --------------------------------- Truehit -------------------------------- */}
        <script
          type='text/javascript'
          dangerouslySetInnerHTML={{
            __html: `
                __th_page="privacy-policy";
              `
          }}
        />

      </Head>
      <Layout sessionSevId={sessionSevId}>
        <div className='container' style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.5)' : 'unset' }}>
          {(!isEmpty(privacyDataArray[0]) && privacyDataArray[0].data !== null) &&
            (!isEmpty(privacyDataArray[1]) && privacyDataArray[1].data !== null) &&
            (!isEmpty(privacyDataArray[2]) && privacyDataArray[2].data !== null)
            ? <SectionWrapper seq={_findIndex} themeColor={'#1414ff'} >
              <div className='tab-link'>
                <div className='tab-button'>
                  {arrayName.map((item, index) => (
                    <li key={item}>
                      <label >
                        <input name='tab-control' onChange={() => handleOnChange(index)} type='checkbox' value={checkedState[index]} checked={checkedState[index] ? true : ''}></input>
                        <span >{`${item}`}
                        </span>
                      </label>
                    </li>
                  ))
                  }
                </div>
                <div className='indicator'></div>
              </div>
              <div className='content-container'>
                <div className={`policy ${_findIndex === 0 ? 'open-0' : ''}`} dangerouslySetInnerHTML={{ __html: privacyDataArray[0] }} />
                <div className={`policy ${_findIndex === 1 ? 'open-1' : ''}`} dangerouslySetInnerHTML={{ __html: privacyDataArray[1] }} />
                <div className={`policy ${_findIndex === 2 ? 'open-2' : ''}`} dangerouslySetInnerHTML={{ __html: privacyDataArray[2] }} />
              </div>
            </SectionWrapper>
            : 'ยังไม่ได้กำหนด privacy-policy'}
        </div>
      </Layout>

    </>
  );
};

const SectionWrapper = styled.div`
    padding-top: 0.75rem;
    .tab-link {
      padding-bottom: 10px;
      padding-left: 10px;
      padding-right: 10px;
    }
    .tab-button {  
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;
      justify-content: space-between;
      align-items: flex-end;
      flex-wrap: wrap;
      list-style-type: none;
      height: 50px;
      width: 100%;
      align-items: center;
      border-bottom: 4px solid #e3dede;
      @media (max-width: 475px) {
        padding-bottom: 70px ;
      }
      li {
        box-sizing: border-box;
        flex: 1;
        width: 25%;
        padding: 0 10px;
        text-align: center;
        display: list-item;
       input:checked + span {
            color: ${(props) => props.themeColor};
          }
        label {
          white-space: initial;
          color: silver;
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
          cursor: pointer;
          transition: all 0.5s ease-in-out;
          font-weight: bold;
          font-size: 16px;
          width: 100%;
          @media (max-width: 992px) {
              font-size: 14px;
          }
          @media (max-width: 475px) {
              font-size: 14px;
          }
          @media (max-width: 350px) {
            font-size: 12px;
          }
          @media (max-width: 280px) {
            font-size: 10px;
          }
          &:hover {
            color: #585858;
          }
          input {
            display: none;
            transition: all 0.5s ease-in-out;

          }
        }
      }
    }
    
    .indicator {
        position: relative;
        width: calc(100% / 3);
        left: calc(calc(100% / 3) * ${(props) => props.seq} );
        max-width: 100%;
        transition: all 0.33s ease-in-out;   
        height: 4px;
        background: ${(props) => props.themeColor};
        border-radius: 1px;
        margin-top: -22px;
        top: 8px;
    }
    
    
    .content-container {
      display: block;
      position: relative;
      margin: 30px 0;
      overflow-y: auto;   
      height: auto;
      min-height: 620px;
      &::-webkit-scrollbar{
        width: 6px;
        background-color: #e3dede;
        border-radius: 10px;
      }
      
      &::-webkit-scrollbar-track {
        background-color: #ffffff21;
        border-radius: 10px;
      }
      
      &::-webkit-scrollbar-thumb{
        border-radius: 10px;
        background-color: ${(props) => props.themeColor};
      }
      @media (max-width: 992px) {
        min-height: 700px;
      }
      @media (max-width: 475px) {
        min-height: 390px;
      }
      @media (max-width: 280px) {
        min-height: 370px;
      }
      .policy {
        position: absolute;
        top: 0;
        left: -250%;
        width: 100%;
        opacity: 0;
        overflow: hidden;
        transition: all 1.5s ease-in-out;
        &.open-0 {
          left: 0;
          opacity: 1;
          width: 100%;
        }
        &.open-1 {
          left: 0;
          opacity: 1;
          width: 100%;
        }
        &.open-2 {
          left: 0;
          opacity: 1;
          width: 100%;
        }
      } 
    }
`;

export async function getServerSideProps (ctx) {
  const initProps = {
    statusCode: 200,
    errMessage: null,
    privacyDataArray: [],
    dataAdsHeader: null
  };
  async function getPolicyData () {
    const resDataI = await GET('/api/privacy-policy?policy=1');
    const resDataII = await GET('/api/privacy-policy?policy=2');
    const resDataIII = await GET('/api/privacy-policy?policy=3');
    const res = Promise.all([resDataI, resDataII, resDataIII]);
    try {
      const adsHeaders = await GET('/api/headerAds');
      if (!isEmpty(adsHeaders)) {
        initProps.dataAdsHeader = adsHeaders;
      }
      const result = await res;
      return [result[0], result[1], result[2]];
    } catch (err) {
      console.error(`${timestamp()} ==========> PAGE_INDEX ERROR : `, err.message);
      initProps.errMessage = err.message;
      initProps.statusCode = err?.response?.status || 500;
    }
  };

  try {
    const privacyDataArray = await getPolicyData();
    if (!isEmpty(privacyDataArray)) initProps.privacyDataArray = privacyDataArray || [];
  } catch (err) {
    console.error(`${timestamp()} ==========> PAGE_INDEX ERROR : `, err.message);
    initProps.errMessage = err.message;
    initProps.statusCode = err?.response?.status || 500;
  }

  return {
    props: initProps
  };
}

export default PrivacyPolicyPage;
